/**
 *   Generated file. Do not edit
 */

import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getName: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/group/{groupId}/name',
    path: '/1025/{groupId}/0',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putName: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/group/{groupId}/name',
    path: '/1025/{groupId}/0',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  changePassword: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/group/{groupId}/password',
    path: '/1025/{groupId}/2',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  changePasswordKey: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/group/{groupId}/password-key',
    path: '/1025/{groupId}/2',
  } as ServiceCallType<Uint8Array, void>,

  getSessionLifetime: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/group/{groupId}/session-lifetime',
    path: '/1025/{groupId}/4',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putSessionLifetime: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/group/{groupId}/session-lifetime',
    path: '/1025/{groupId}/4',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getAlias: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/group/{groupId}/alias',
    path: '/1025/{groupId}/5',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putAlias: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/group/{groupId}/alias',
    path: '/1025/{groupId}/5',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  create: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/group/{groupId}/create',
    path: '/1025/{groupId}/65535',
  } as ServiceCallType<void, void>,
};
